function paymentOrder(refIdValue: string, url: string) {
  const form = document.createElement('form')
  form.setAttribute('method', 'POST')
  form.setAttribute('action', url)
  form.setAttribute('target', '_self')
  const hiddenField = document.createElement('input')
  hiddenField.setAttribute('name', 'RefId')
  hiddenField.setAttribute('value', refIdValue)
  form.appendChild(hiddenField)
  // let hiddenFieldMobile = document.createElement('input')
  // hiddenFieldMobile.setAttribute('name', 'mobileap')
  // hiddenFieldMobile.setAttribute('value', mobileNumber)
  // form.appendChild(hiddenFieldMobile)
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}
export default paymentOrder
